import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { SectionHeader, StagePill, RatingBadge } from "@/components/common/Widgets";
import { fmtDate } from "@/lib/format";

export default function ApprovalsPage() {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/applications", { params: { stage: "APPROVAL" } });
        setApps(res.data);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="space-y-4">
      <SectionHeader title="Approvals Queue" subtitle="Applications awaiting your action." />
      <Card className="p-0 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-muted/40 text-xs uppercase tracking-wide text-muted-foreground">
              <tr><th className="text-left px-3 py-2.5">Ref</th><th className="text-left px-3 py-2.5">Customer</th><th className="text-left px-3 py-2.5">Type</th><th className="text-right px-3 py-2.5">CC (₹L)</th><th className="text-right px-3 py-2.5">TL (₹L)</th><th className="text-left px-3 py-2.5">Stage</th><th className="text-left px-3 py-2.5">Updated</th><th></th></tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={8} className="text-center py-8 text-muted-foreground">Loading…</td></tr>}
              {!loading && apps.length === 0 && <tr><td colSpan={8} className="text-center py-12 text-muted-foreground">Nothing awaiting your approval.</td></tr>}
              {apps.map((a) => (
                <tr key={a.id} className="border-t border-border hover:bg-muted/30">
                  <td className="px-3 py-2 mono text-xs">{a.ref_no}</td>
                  <td className="px-3 py-2 font-medium">{a.customer_name}</td>
                  <td className="px-3 py-2 text-xs">{a.loan_type}</td>
                  <td className="px-3 py-2 num-right">{a.cc_proposed ?? "—"}</td>
                  <td className="px-3 py-2 num-right">{a.tl_proposed ?? "—"}</td>
                  <td className="px-3 py-2"><StagePill stage={a.stage} /></td>
                  <td className="px-3 py-2 text-xs text-muted-foreground mono">{fmtDate(a.updated_at)}</td>
                  <td className="px-3 py-2 text-right"><Link to={`/applications/${a.id}`}><Button size="sm">Review</Button></Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
